import {Router} from '@angular/router';
import {inject} from '@angular/core';
import {Component} from '@angular/core';
import {WaInputDirective} from 'angular-awesome';
import {WaIconDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTreeDirective} from 'angular-awesome';
import {WaTreeItemDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-frameworks-aside',
	templateUrl:'./FrameworksAsidePage.html',
	styles: [],
	styleUrls:['./FrameworksAsidePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaInputDirective,
		WaIconDirective,
		WaTextDirective,
		WaTreeDirective,
		WaTreeItemDirective,
],
	standalone:true
})
export class FrameworksAsidePage
{
	private router: Router = inject(Router);
	navigateToFramework(frameworkId: string) {
	    this.router.navigate(['/frameworks', frameworkId]);
	}
	navigateToComponent(frameworkId: string, slug: string) {
	    this.router.navigate(['/frameworks', frameworkId, slug]);
	}
	navigateToPlugin(pluginId: string) {
	    this.router.navigate(['/plugins'], {fragment: pluginId});
	}
	onFilterChange(event: any) {
	    const query = (event?.target?.value || '').toLowerCase().trim();
	    const items = document.querySelectorAll('wa-tree-item');
	    items.forEach((item: any) => {
	        const text = item.textContent?.toLowerCase() || '';
	        if (!query || text.includes(query)) {
	            item.style.display = '';
	            let parent = item.parentElement?.closest('wa-tree-item');
	            while (parent) {
	                parent.style.display = '';
	                parent = parent.parentElement?.closest('wa-tree-item');
	            }
	        } else {
	            item.style.display = 'none';
	        }
	    });
	    items.forEach((item: any) => {
	        if (item.style.display === 'none') {
	            const visibleChild = item.querySelector('wa-tree-item:not([style*="display: none"])');
	            if (visibleChild) {
	                item.style.display = '';
	            }
	        }
	    });
	}

}
